import * as React from 'react';

const OlapicContext = /*#__PURE__*/ React.createContext({});
const OlapicProvider = ({ sku , apiKey , url , children ,  })=>{
    const value = React.useMemo(()=>({
            sku,
            apiKey,
            url
        })
    , [
        sku,
        apiKey,
        url
    ]);
    return /*#__PURE__*/ React.createElement(OlapicContext.Provider, {
        value: value
    }, children);
};
const useOlapicContext = ()=>React.useContext(OlapicContext)
;

export { OlapicProvider, OlapicContext as default, useOlapicContext };
//# sourceMappingURL=OlapicContext.js.map
